import { Wrapper, Section, DescriptionText, VideosWrapper, Col } from "./style";
import Image1 from "../../assets/images/img31.jpg"
import SectionHeader from "components/SectionHeader";
import FeaturedVideo from "components/FeaturedVideo";
import VideosList from "components/VideosList";

const VideosSection = ({pTop, pBottom, bgColor}: any) => (
  <Section
    className="VideosSection"
    sx={{
      backgroundColor: `${bgColor}`,
      paddingTop: `calc(${pTop} * 0.52)`,
      paddingBottom: `calc(${pBottom} * 0.52)`,

      "@media (min-width: 768px)": {
        paddingTop: `calc(${pTop} * 0.8)`,
        paddingBottom: `calc(${pBottom} * 0.8)`,
      },
      "@media (min-width: 1200px)": {
        paddingTop: `calc(${pTop} * 1)`,
        paddingBottom: `calc(${pBottom} * 1)`
      }
    }}
  >
    <Wrapper>
      <SectionHeader
        extraClass="headingHead"
        heading="Accelerate Your Career By Becoming a 6ix Leads Expert"
        tagline="Training"
      >
        <DescriptionText
          variant="body1"
        >
          Learn how to launch investor leads campaigns that reach more investors, attract capital and improve your company’s reputation.
        </DescriptionText>
      </SectionHeader>
      <VideosWrapper>
        <Col>
          <FeaturedVideo
            imageUrl={Image1}
            heading="How to Design & Build Your Investor Website on 6ix"
            caption="Episode 1"
          />
        </Col>
        <Col>
          <VideosList />
        </Col>
      </VideosWrapper>
    </Wrapper>
  </Section>
);

export default VideosSection;